export default __webpack_public_path__ + "static/media/woocommerce-customthankyou-selection.f0332084.gif";